/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's opyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

import { loadingContext } from "./LoadingContext.store";
import { LoadingView } from "./LoadingView";

export type { LoadingContextType, HandleChangeStore } from "./LoadingContext.types";
export { loadingContext, useLoading } from "./LoadingContext.store";
export {
  getGlobalLoadingStore,
  setGlobalLoadingStore,
  addGlobalLoading,
  removeGlobalLoading,
  addGlobalRequestLoading,
  removeGlobalRequestLoading,
} from "./LoadingContext.global";
export { LoadingView } from "./LoadingView";

const { Provider } = loadingContext;

/**
 * Wraps children with the loading context provider and overlay.
 *
 * @param props - Component props with children
 * @returns The loading provider element
 */
export const LoadingProvider: ComponentWithChildren = ({ children }) => {
  return (
    <Provider>
      <LoadingView>{children}</LoadingView>
    </Provider>
  );
};
